import React, { useMemo,useState } from 'react';
import { formatDate, formatDateEur } from '../../../shared/utility';
import StatusProgressLine from '../StatusProgressLine/StatusProgressLine';
import { CIActions, CIContainer, CIContent, CIData, CITitle, UpdateLink } from './CampaignItem.styled';
import GroupIcon from '@mui/icons-material/Group';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ConfirmationModal from '../../UI/ConfirmationModal/ConfirmationModal'
import Axios from '../../../axios-proas'
import {Notyf} from "notyf";
import theme from '../../../styles/theme';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import CancelIcon from '@mui/icons-material/Cancel';
import EditIcon from '@mui/icons-material/Edit';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';
import { CTooltip } from '../../UI/CTooltip/CTooltip';
import { useTheme } from 'styled-components';
function CampaignItem({ campaign, getCampaigns, itemIndex, raisonSociale }) {     
     const [confirmationModalShow, setConfirmationModalShow] = useState(false);
     const notyf = new Notyf();
     const theme = useTheme()
     const deleteCompagneClickHandler = (Uid) => {
        Axios.delete(`campaign/${Uid}/deleteCompagne`).then(response => {
            getCampaigns()
           setConfirmationModalShow(false)
            notyf.success("La campagne a bien été supprimée")
        }).catch(response => {
           
            notyf.error("generatedErrorMessage")
        })
    }
    return (
        <>
        <CIContainer style={{display:"flex"}}>
            <div style={{padding: "4px 0px",
                        fontSize: "20px",
                        height:"45px",
                        width: "45px",
                        border: "1px solid #809FB8",
                        borderRadius: "18px",
                        textAlign: "center",
                        alignSelf :"center",
                        background: campaign?.type == 1 ? '#fab134' :'#80d424',
                        color: "#505050"}}>
                <p style={{color:"#505050"}}>{itemIndex+1}</p>
            </div>
            <div style={{width:"100%"}}>
                <CIContent>
                        <CIData style={{
                            display: 'block', width:"75%",}}>
                        <CITitle>
                  {campaign?.libelle}&nbsp;&nbsp;{campaign?.anneeReference}
                        </CITitle>
                      

                   
                            <StatusProgressLine
                              status={formatDateEur(new Date()) >= formatDateEur(new Date(campaign?.dateFermetureSls)) ? "completed" : "inProgress"}
                              activee={campaign?.estActive}
                              reference={campaign?.anneeReference}
                              dateOuvertureOps={campaign?.dateOuvertureOps}
                              dateFermetureOps={campaign?.dateFermetureOps}
                              dateOuvertureSls={campaign?.dateOuvertureSls}
                              dateFermetureSls={campaign?.dateFermetureSls}
                              typeCampagne={campaign?.type }
                            />
                    </CIData>
                        <CIActions style={{ width: "25%" }}>
                        <div >
                                <div style={{display: 'flex', marginBottom: "13px"}}>
                                        <span style={{ color: theme.colors.icdgray, fontSize: "medium", marginTop: "2px" }}>Active : </span>
                                        {campaign?.estActive ?
                                        <ToggleOnIcon
                                         
                                            fontSize="large"
                                            style={{ color: theme.colors.secondary, marginLeft: '0.25rem', cursor: 'pointer', marginTop: "-5px" }}
                                           />
                                            :
                                        <ToggleOffIcon
                                          
                                            fontSize="large"
                                            style={{ color: theme.colors.younovGray, marginLeft: '0.25rem', cursor: 'pointer', marginTop: "-5px" }}
                                           />
                                         }
                                </div>
                     
                                <div style={{ display: "flex", justifyContent: "right" }}>
                                    <CTooltip title={"Modifier" }>
                                        <UpdateLink
                                            to={"/newCampaign/" + campaign?.id}
                                            state={{ uid: campaign?.bailleurId, raisonSociale: raisonSociale }}
                                            
                                            > 
                                            <EditIcon style={{color: theme.colors.primary, cursor: 'pointer'}}/>
                                        </UpdateLink>
                                    </CTooltip>
                      

                                </div>
                        </div>
                        
                    
                      
                    
                        
                    </CIActions>
                        
                </CIContent>
            </div>
        </CIContainer>
         <ConfirmationModal 
         show={confirmationModalShow}
         modalClosed={() => setConfirmationModalShow(false)}
         confirm={()=>deleteCompagneClickHandler(campaign?.uid)}
         cancel={() => setConfirmationModalShow(false)}
         title={"Confirmation de suppression"}
         message={`Êtes-vous sûr de vouloir supprimer cette campagne ?`}
/>
</>
    );
}

export default CampaignItem;

